import script from "./UpdateProfileModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateProfileModal.vue?vue&type=script&setup=true&lang=ts"

import "./UpdateProfileModal.vue?vue&type=style&index=0&id=0be0b788&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0be0b788"]])

export default __exports__